package one.healthium.insights.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class ContentScreenDto(
    @SerialName("id") val id: String? = null,
    @SerialName("navbar") val navbar: NavbarDto? = null,
    @SerialName("preview") val preview: ContentPreviewDto? = null,
    @SerialName("content") val content: List<ContentEntryDto>,
)
